import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getCategoryById } from "../../api/categoryService";
import { getErrorMessage } from "../../utils/errorHandler";
import StatusBadge from "../Shared/StatusBadge";
import RecordActions from "../Shared/RecordActions";
import FullPageLoader from "../../common/FullPageLoader";

export default function CategoryView() {
  const navigate = useNavigate();
  const { slug } = useParams();
  const [category, setCategory] = useState(null);
  const [loading, setLoading] = useState(false);
  const fetchCategory = async () => {
    setLoading(true);
    try {
      const res = await getCategoryById(slug);
      if (res?.data?.data) {
        setCategory(res.data.data);
      } else if (res?.data) {
        setCategory(res.data);
      } else {
        setCategory(null);
      }
    } catch (error) {
      console.error("Failed to fetch category", error);
      alert(getErrorMessage(error));
      setCategory(null);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (slug) {
      fetchCategory();
    }
  }, [slug]);
  if (loading) {
    return <FullPageLoader text="Loading category..." />;
  }
  if (!category) {
    return (
      <div className="container py-5">
        <h3>Category Not Found</h3>
      </div>
    );
  }
  return (
    <div className="container-fluid p-4">
      <RecordActions
        onBack={() => navigate("/categories")}
        onEdit={() =>
          navigate(`/category/edit/${category?.seo?.slug || slug}`, {
            state: {
              slug: category?.seo?.slug || slug,
              categoryId: category._id,
            },
          })
        }
      />
      <div className="card">
        <div className="row g-0">
          {/* Left Side Image */}
          <div className="col-md-4 d-flex align-items-center justify-content-center p-3 bg-light">
            {category.metaImageUrl && (
              <img
                src={category.metaImageUrl}
                alt={category.name || "Category"}
                className="img-fluid rounded-3 shadow-sm"
                style={{
                  maxHeight: "250px",
                  objectFit: "contain",
                }}
              />
            )}
          </div>

          {/* Right Side Content */}
          <div className="col-md-8">
            <div className="p-4">
              <h2 className="fw-bold mb-4">{category.name || "-"}</h2>

              <div className="mb-3">
                <strong>Description:</strong>
                <p className="text-muted mb-0">{category.description || "No description"}</p>
              </div>

              <div className="mb-3">
                <strong>Tagline:</strong>
                <p className="text-muted mb-0">{category.tagline || "No tagline"}</p>
              </div>

              <div className="mb-3">
                <strong>HSN:</strong>
                <p className="text-muted mb-0">{category.hsnCode || "N/A"}</p>
              </div>

              <div className="mb-3">
                <strong>Tax Applied:</strong>
                <p className="text-muted mb-0">{category.taxApplied ? "Yes" : "No"}</p>
              </div>
              <strong>Status:</strong>
              <p className="fw-semibold mb-0 text-dark">
                <StatusBadge status={category.status} />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
